"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const TreeCategory = props => props.children || null;
TreeCategory.displayName = 'TreeCategory';
TreeCategory.propTypes = {
    id: prop_types_1.default.string.isRequired,
    icon: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    hasSelection: prop_types_1.default.bool,
};
exports.default = TreeCategory;
